import MockAdapter from "axios-mock-adapter";
import api from "../utils/apiUtility";

const mock = new MockAdapter(api, { delayResponse: 200 });
declare const console: any;
declare const setTimeout: any;
// Function to simulate payment processing
const requestPayment = async (data: { payments: { payment_method: any }[] }) => {
  // Extract the payment method from the request data
  const payment_method = data.payments[0].payment_method;

  // Define different responses based on the payment method
  if (payment_method === "credit_card") {
    return [
      200,
      {
        id: "or_Qokl09gh1h3qD1NM",
        code: "ORW8IOIVM2",
        amount: 2990,
        currency: "BRL",
        closed: true,
        items: [
          {
            id: "oi_L7QkN1KtxtMa2poR",
            type: "product",
            description: "Chaveiro do Tesseract",
            amount: 2990,
            quantity: 1,
            status: "active",
            created_at: "2024-06-06T23:44:28Z",
            updated_at: "2024-06-06T23:44:28Z",
            code: "123",
          },
        ],
        customer: {
          id: "cus_z89QVz0HLH3bPZ5v",
          name: "Tony Stark",
          document: "03154435026",
          type: "individual",
          delinquent: false,
          created_at: "2024-06-06T23:44:28Z",
          updated_at: "2024-06-06T23:44:28Z",
          phones: {
            home_phone: {
              country_code: "55",
              number: "000000000",
              area_code: "11",
            },
            mobile_phone: {
              country_code: "55",
              number: "000000000",
              area_code: "11",
            },
          },
        },
        status: "paid",
        created_at: "2024-06-06T23:44:28Z",
        updated_at: "2024-06-06T23:44:28Z",
        closed_at: "2024-06-06T23:44:28Z",
        charges: [
          {
            id: "ch_2ZvmXp5FZFEj815Y",
            code: "ORW8IOIVM2",
            gateway_id: "524486",
            amount: 2990,
            status: "paid",
            currency: "BRL",
            payment_method: "credit_card",
            created_at: "2024-06-06T23:44:28Z",
            updated_at: "2024-06-06T23:44:28Z",
            customer: {
              id: "cus_z89QVz0HLH3bPZ5v",
              name: "Tony Stark",
              document: "03154435026",
              type: "individual",
              delinquent: false,
              created_at: "2024-06-06T23:44:28Z",
              updated_at: "2024-06-06T23:44:28Z",
              phones: {
                home_phone: {
                  country_code: "55",
                  number: "000000000",
                  area_code: "11",
                },
                mobile_phone: {
                  country_code: "55",
                  number: "000000000",
                  area_code: "11",
                },
              },
            },
            last_transaction: {
              id: "tran_lXx3arRTYTXa7P5m",
              transaction_type: "credit_card",
              amount: 2990,
              status: "paid",
              success: true,
              created_at: "2024-06-06T23:44:28Z",
              updated_at: "2024-06-06T23:44:28Z",
              gateway_response: {},
              antifraud_response: {},
              metadata: {},
            },
          },
        ],
      },
    ];
  } else if (payment_method === "pix") {
    return [
      200,
      {
        id: "or_Qokl09gh1h3qD1NM",
        code: "ORW8IOIVM2",
        amount: 2990,
        currency: "BRL",
        closed: true,
        items: [
          {
            id: "oi_L7QkN1KtxtMa2poR",
            type: "product",
            description: "Chaveiro do Tesseract",
            amount: 2990,
            quantity: 1,
            status: "active",
            created_at: "2024-06-06T23:44:28Z",
            updated_at: "2024-06-06T23:44:28Z",
            code: "123",
          },
        ],
        customer: {
          id: "cus_z89QVz0HLH3bPZ5v",
          name: "Tony Stark",
          document: "03154435026",
          type: "individual",
          delinquent: false,
          created_at: "2024-06-06T23:44:28Z",
          updated_at: "2024-06-06T23:44:28Z",
          phones: {
            home_phone: {
              country_code: "55",
              number: "000000000",
              area_code: "11",
            },
            mobile_phone: {
              country_code: "55",
              number: "000000000",
              area_code: "11",
            },
          },
        },
        status: "pending",
        created_at: "2024-06-06T23:44:28Z",
        updated_at: "2024-06-06T23:44:28Z",
        closed_at: "2024-06-06T23:44:28Z",
        charges: [
          {
            id: "ch_2ZvmXp5FZFEj815Y",
            code: "ORW8IOIVM2",
            gateway_id: "524486",
            amount: 2990,
            status: "pending",
            currency: "BRL",
            payment_method: "pix",
            created_at: "2024-06-06T23:44:28Z",
            updated_at: "2024-06-06T23:44:28Z",
            customer: {
              id: "cus_z89QVz0HLH3bPZ5v",
              name: "Tony Stark",
              document: "03154435026",
              type: "individual",
              delinquent: false,
              created_at: "2024-06-06T23:44:28Z",
              updated_at: "2024-06-06T23:44:28Z",
              phones: {
                home_phone: {
                  country_code: "55",
                  number: "000000000",
                  area_code: "11",
                },
                mobile_phone: {
                  country_code: "55",
                  number: "000000000",
                  area_code: "11",
                },
              },
            },
            last_transaction: {
              pix_provider_tid: "524486",
              qr_code:
                "00020101021226480019BR.COM.STONE.QRCODE0108A37F8712020912345678927820 014BR.GOV.BCB.PIX2560sandbox-qrcode.stone.com.br/api/v2/qr/sGY7FyVExavqkzFvkQu MXA28580010BR.COM.ELO0104516002151234567890000000308933BB1100401P520400 00530398654041.005802BR5911STONE TESTE6009SAO PAULO62600522sGY7FyVExavqkzFvkQuMXA50300017BR.GOV.BCB.BRCODE01051.0.0 80500010BR.COM.ELO01100915132023020200030201040613202363043BA1",
              qr_code_url:
                "https://api.pagar.me/core/v5/transactions/tran_lXx3arRTYTXa7P5m/qrcode?payment_method=pix",
              expires_at: "2024-06-07T01:44:28Z",
              additional_information: [
                {
                  name: "information",
                  value: "number",
                },
              ],
              id: "tran_lXx3arRTYTXa7P5m",
              transaction_type: "pix",
              gateway_id: "524486",
              amount: 2990,
              status: "waiting_payment",
              success: true,
              created_at: "2024-06-06T23:44:28Z",
              updated_at: "2024-06-06T23:44:28Z",
              gateway_response: {},
              antifraud_response: {},
              metadata: {},
            },
          },
        ],
      },
    ];
  } else {
    // Default response for unsupported payment methods
    return [400, { message: "Unsupported payment method" }];
  }
};

// Mock endpoint for payment status
mock.onGet("/users").reply(200, 
  {
    "users": [
        {
            "id": 1,
            "name": "Jazmine C.",
            "photo": "https://george-fx.github.io/apitex_api/assets/users/02.png"
        },
        {
            "id": 2,
            "name": "Bryan C.",
            "photo": "https://george-fx.github.io/apitex_api/assets/users/03.png"
        },
        {
            "id": 3,
            "name": "Dalia H.",
            "photo": "https://george-fx.github.io/apitex_api/assets/users/04.png"
        },
        {
            "id": 4,
            "name": "Marcus B.",
            "photo": "https://george-fx.github.io/apitex_api/assets/users/05.png"
        },
        {
            "id": 5,
            "name": "Angel B.",
            "photo": "https://george-fx.github.io/apitex_api/assets/users/06.png"
        }
    ]
}

);

// mock.onGet("/coberturas").reply(200, 
//   {
//     "coberturas": [
//       {
//           "id": 1,
//           "name": "Telemedicina Familiar",
//           "type": "Money transfer",
//           "amount": 136.00,
//           "currency": "USD",
//           "direction": "in",
//           "transactionType": "credit",
//           "icon": "https://george-fx.github.io/apitex_api/assets/types/01.png"
//       },
//       {
//           "id": 2,
//           "name": "Televeterinaria",
//           "type": "Utility bills",
//           "amount": 245.27,
//           "currency": "USD",
//           "direction": "out",
//           "transactionType": "debit",
//           "icon": "https://george-fx.github.io/apitex_api/assets/types/02.png"
//       },
//       {
//           "id": 3,
//           "name": "Paypal",
//           "type": "Deposits",
//           "amount": 500.00,
//           "currency": "USD",
//           "direction": "in",
//           "transactionType": "credit",
//           "icon": "https://george-fx.github.io/apitex_api/assets/types/03.png"
//       }
//     ]
//   }
// );


// Mock endpoint for partner
// mock.onGet("/partner").reply(200, {
//   affiliateName: "Mathvsl",
//   productName: "Game Assist",
//   highlights: [
//     { url: "https://www.instagram.com/reel/DFJMpYsvhdF/?igsh=bXBrcms0ejV4NHAx" },
//     { url: "https://www.instagram.com/reel/DEBFIauvHv5/?igsh=MW1kcWZjNjdqYzE3cA==" },
//     { url: "https://www.instagram.com/reel/DDX1SsdPA9J/?igsh=dXI1ZXVlZ2kxMDR2" }
//   ],
//   profile: {
//     avatar: null,
//     bio: "Assinatura, Proteção e um ano de sorteios toda semana",
//     description: "Tudo para sua JOGATINA!",
//     productName: undefined,
//   },
// });


// Mock endpoint for affiliate links
mock.onGet(new RegExp(`/affiliate-links/[a-zA-Z0-9]+`)).reply(200, {
  product_name: "Game Assist",
  link_id: "UPDQ-Aelv-Wadm",
  affiliate_id: "a0ce48ce-3a10-4ccc-8094-9ec7119e54fd",
  plan_id: "95d8d584-387b-4958-b137-e4492c37d764",
  url: "https://pay.link/p/UPDQ-Aelv-Wadm",
  expirationDate: "2025-12-15T22:59:23.317Z",
  status: "active",
});


// Mock endpoint for affiliate links
mock.onGet(new RegExp(`/affiliates/[a-zA-Z0-9]+`)).reply(200, 
  {
  affiliate_id: "a0ce48ce-3a10-4ccc-8094-9ec7119e54fd",
  affiliate_name: "Mathvsl",
  status: "active",
  profile: {
    canal: "mathvsl",
    bio: [
      "Assinatura, Proteção e um ano de sorteios toda semana",
      "Tudo para sua JOGATINA!"
    ],
    name: "Math",
    gender: "homem",
    age: 25,
    occupation: "influenciador de games",
    description: "Math.",
    highlights: [
      { url: "https://www.instagram.com/p/DD-iFievbb3/", title: "New collection" },
      { url: "https://www.instagram.com/p/DD2KmDtxs9F/", title: "Festival fashion" },
      { url: "https://www.instagram.com/p/DD2KmDtxs9F/", title: "Summer lookbook" },
    ],
    partnerDetails: {
      verifiedStatus: "Parceiro verificado",
      partnership: "Parceria com ZENTEK",
    },
    actions: [
      { text: "Participe de bate-papo em grupo no WhatsApp" , url: "https://chat.whatsapp.com/invite/123456" },
      { text: "Siga no Instagram" , url: "https://www.instagram.com/mathvsl" },
      { text: "Siga no Twitter", url: "https://twitter.com/mathvsl" },
    ],
    avatar: "a0ce48ce-3a10-4ccc-8094-9ec7119e54fd.jpg"
  },
});


// Mock endpoint for subscriber (assinante)
mock.onGet("/assinante").reply(200, {
  nome: "Lucas Almeida",
  avatar: null,
  telefone: "+55 11 98765-4321",
  nascimento: "1992-08-15",
  email: "lucasalmeida@gmail.com",
  endereco: "Av. Paulista, 1500, São Paulo, SP, Brasil",
});



// Mock endpoint for payment status
mock.onGet("/coberturas").reply(200, 
 {
      "_id": "635f8a5a6c9d4f7c8e9d5b12",
      "name": "Comprehensive Health & Security Plan",
      "type": "Black",
      "description": "This plan includes extensive health and security benefits for you and your family.",
      "categories": [
        {
          "_id": "635f8a5a6c9d4f7c8e9d5b13",
          "name": "Vida em Equilíbrio",
          "description": "Focus on health and wellness for balanced living.",
          "coverages": [
            {
              "benefitName": "Telemedicina",
              "coverageType": "consultas_médicas",
              "coverageAmount": "01 (um) atendimento por mês",
              "usageLimit": "acesso 24/7",
              "waitingPeriod": "48 horas úteis",
              "includedServices": [
                "As consultas emergenciais são atendidas por médico Clínicos, após a avaliação, havendo necessidade de um especialista, o médico que atende na emergência fará o encaminhamento a especialidade para continuidade do atendimento."
              ],
              "exclusions": [
                "Internações, procedimentos que exigam exames físicos do paciente"
              ],
              "eligibleBeneficiaries": "Titular",
              "provider": {
                "type": "Tem Saúde",
                "name": "VidaAtiva Assist",
                "contact": {
                  "phone": "Central: (11) 4000-1640 Capitais e regiões metropolitanas) / 0800 836 8836 (Demais localidades) / WhatsApp: (11) 5108-1743",
                  "email": "suporte@zentek.com.br",
                  "website": "https://www.zentek.com.br"
                }
              },
              "activationProcess": "Acesso via aplicativo, site ou telefone",
              "supportContact": {
                "phone": "Central: (11) 4000-1640 Capitais e regiões metropolitanas) / 0800 836 8836 (Demais localidades) / WhatsApp: (11) 5108-1743",
                "email": "suporte@zentek.com.br",
                "appLink": "https://www.zentek.com.br"
              },
              "benefitDuration": "O atendimento estará disponível enquanto o cliente estiver com a assinatura ativa e sem inadimplência",
              "adjustmentRules": "O Provedor  reserva-se o direito de fazer alterações nos serviços a qualquer momento, com o objetivo de melhorar a qualidade, a abrangência ou a eficácia dos serviços oferecidos aos clientes.",
              "cancellationPolicy": {
                "terms": "Pode ser cancelado a qualquer momento, via aplicativo.",
                "penalty": "Sem multas"
              }
            },
            {
              "benefitName": "Descontos em Farmácia",
              "coverageType": "desconto_farmácia",
              "coverageAmount": "Ilimitado",
              "usageLimit": "acesso 24/7",
              "waitingPeriod": "48 horas úteis",
              "includedServices": [
                "Desconto de até 20% (vinte por cento) para a aquisição de medicamentos nas farmácias ligadas à Rede VidaLink. Os descontos são aplicados automaticamente no momento da compra."
              ],
              "exclusions": [
                "Os produtos que não considerados medicamentos pela ANVISA"
              ],
              "eligibleBeneficiaries": "Titular",
              "provider": {
                "type": "Tem Saúde",
                "name": "VidaAtiva Assist",
                "contact": {
                  "phone": "Central: (11) 4000-1640 Capitais e regiões metropolitanas) / 0800 836 8836 (Demais localidades) / WhatsApp: (11) 5108-1743",
                  "email": "suporte@zentek.com.br",
                  "website": "https://www.zentek.com.br"
                }
              },
              "activationProcess": "Acesso via aplicativo",
              "supportContact": {
                "phone": "Central: (11) 4000-1640 Capitais e regiões metropolitanas) / 0800 836 8836 (Demais localidades) / WhatsApp: (11) 5108-1743",
                "email": "suporte@zentek.com.br",
                "appLink": "https://www.zentek.com.br"
              },
              "benefitDuration": "O atendimento estará disponível enquanto o cliente estiver com a assinatura ativa e sem inadimplência",
              "adjustmentRules": "O Provedor  reserva-se o direito de fazer alterações nos serviços a qualquer momento, com o objetivo de melhorar a qualidade, a abrangência ou a eficácia dos serviços oferecidos aos clientes.",
              "cancellationPolicy": {
                "terms": "Pode ser cancelado a qualquer momento, via aplicativo.",
                "penalty": "Sem multas"
              }
            },
            {
              "benefitName": "Agenda Pessoal Digital",
              "coverageType": "agenda_pessoal",
              "coverageAmount": "Ilimitado",
              "usageLimit": "acesso 24/7",
              "waitingPeriod": "48 horas úteis",
              "includedServices": [
                "Ferramenta digital que permite organizar comprimissos de forma simples e acessível."
              ],
              "exclusions": [
                "n/a"
              ],
              "eligibleBeneficiaries": "Titular",
              "provider": {
                "type": "Zentek",
                "name": "VidaAtiva Assist",
                "contact": {
                  "phone": "Aplicativo VidaAssist",
                  "email": "suporte@zentek.com.br",
                  "website": "https://www.zentek.com.br"
                }
              },
              "activationProcess": "Acesso via aplicativo",
              "supportContact": {
                "phone": "Aplicativo VidaAssist",
                "email": "suporte@zentek.com.br",
                "appLink": "https://www.zentek.com.br"
              },
              "benefitDuration": "O serviço estará disponível enquanto o cliente estiver com a assinatura ativa e sem inadimplência",
              "adjustmentRules": "O Provedor  reserva-se o direito de fazer alterações nos serviços a qualquer momento, com o objetivo de melhorar a qualidade, a abrangência ou a eficácia dos serviços oferecidos aos clientes.",
              "cancellationPolicy": {
                "terms": "Pode ser cancelado a qualquer momento, via aplicativo.",
                "penalty": "Sem multas"
              }
            },            
            {
              "benefitName": "Rede de Apoio Emocional",
              "coverageType": "suporte_emocional",
              "coverageAmount": "01 (um) acionamento por vigência da assinatura",
              "usageLimit": "Horário comercial",
              "waitingPeriod": "5 (cinco) dias úteis",
              "includedServices": [
                "Acesso a suporte psicológico e emocional, com atendimento feito por profissionais especializados, disponível para ajudar em momentos de necessidade."
              ],
              "exclusions": [
                "Não faz parte de atendimento contínuo de terapia."
              ],
              "eligibleBeneficiaries": "Titular",
              "provider": {
                "type": "Zentek",
                "name": "VidaAtiva Assist",
                "contact": {
                  "phone": "Aplicativo VidaAssist",
                  "email": "suporte@zentek.com.br",
                  "website": "https://www.zentek.com.br"
                }
              },
              "activationProcess": "Acesso via aplicativo",
              "supportContact": {
                "phone": "Aplicativo VidaAssist",
                "email": "suporte@zentek.com.br",
                "appLink": "https://www.zentek.com.br"
              },
              "benefitDuration": "O serviço estará disponível enquanto o cliente estiver com a assinatura ativa e sem inadimplência",
              "adjustmentRules": "O Provedor  reserva-se o direito de fazer alterações nos serviços a qualquer momento, com o objetivo de melhorar a qualidade, a abrangência ou a eficácia dos serviços oferecidos aos clientes.",
              "cancellationPolicy": {
                "terms": "Pode ser cancelado a qualquer momento, via aplicativo.",
                "penalty": "Sem multas"
              }
            },            
            {
              "benefitName": "Televeterinário",
              "coverageType": "tele_veterinário",
              "coverageAmount": "(Validar)",
              "usageLimit": "(Validar)",
              "waitingPeriod": "(Validar)",
              "includedServices": [
                "Consultas veterinárias à distância, prescrição de exames e medicamentos, além de análise de laudos e exames."
              ],
              "exclusions": [
                "Sem atendimentos presenciais, internações e vacinas."
              ],
              "eligibleBeneficiaries": "Titular",
              "provider": {
                "type": "Mawdy",
                "name": "VidaAtiva Assist",
                "contact": {
                  "phone": "Aplicativo VidaAssist",
                  "email": "suporte@zentek.com.br",
                  "website": "https://www.zentek.com.br"
                }
              },
              "activationProcess": "Acesso via aplicativo",
              "supportContact": {
                "phone": "Aplicativo VidaAssist",
                "email": "suporte@zentek.com.br",
                "appLink": "https://www.zentek.com.br"
              },
              "benefitDuration": "O serviço estará disponível enquanto o cliente estiver com a assinatura ativa e sem inadimplência",
              "adjustmentRules": "O Provedor  reserva-se o direito de fazer alterações nos serviços a qualquer momento, com o objetivo de melhorar a qualidade, a abrangência ou a eficácia dos serviços oferecidos aos clientes.",
              "cancellationPolicy": {
                "terms": "Pode ser cancelado a qualquer momento, via aplicativo.",
                "penalty": "Sem multas"
              }
            },            
            {
              "benefitName": "Consulta com Especialistas",
              "coverageType": "consultas_médicas",
              "coverageAmount": "Ilimitado",
              "usageLimit": "acesso 24/7",
              "waitingPeriod": "48 horas úteis",
              "includedServices": [
                "Consultas eletivas com especialistas a um preço fixo e são de uso ilimitado, cobrindo diversas especialidades como Cardiologia, Dermatologia, Psiquiatra, Psicólogo, Nutricionista e Fisioterapia, entre outros, facilitando o acesso a cuidados especializados."
              ],
              "exclusions": [
                "Internações, exames, parto."
              ],
              "eligibleBeneficiaries": "Titular",
              "provider": {
                "type": "Tem Saúde",
                "name": "VidaAtiva Assist",
                "contact": {
                  "phone": "Central: (11) 4000-1640 Capitais e regiões metropolitanas) / 0800 836 8836 (Demais localidades) / WhatsApp: (11) 5108-1743",
                  "email": "suporte@zentek.com.br",
                  "website": "https://www.zentek.com.br"
                }
              },
              "activationProcess": "Acesso via aplicativo, site ou telefone",
              "supportContact": {
                "phone": "Central: (11) 4000-1640 Capitais e regiões metropolitanas) / 0800 836 8836 (Demais localidades) / WhatsApp: (11) 5108-1743",
                "email": "suporte@zentek.com.br",
                "appLink": "https://www.zentek.com.br"
              },
              "benefitDuration": "O atendimento estará disponível enquanto o cliente estiver com a assinatura ativa e sem inadimplência",
              "adjustmentRules": "O Provedor  reserva-se o direito de fazer alterações nos serviços a qualquer momento, com o objetivo de melhorar a qualidade, a abrangência ou a eficácia dos serviços oferecidos aos clientes.",
              "cancellationPolicy": {
                "terms": "Pode ser cancelado a qualquer momento, via aplicativo.",
                "penalty": "Sem multas"
              }
            },            
            {
              "benefitName": "Concierge",
              "coverageType": "concierge",
              "coverageAmount": "01 (um) atendimento por mês",
              "usageLimit": "Horário comercial",
              "waitingPeriod": "48 horas úteis",
              "includedServices": [
                "Um serviço de apoio personalizado, oferecendo assistência no acompanhamento de consultas, ajuda na compra de medicamentos e outras tarefas do dia a dia."
              ],
              "exclusions": [
                "Não se trata de serviço cuidador."
              ],
              "eligibleBeneficiaries": "Titular",
              "provider": {
                "type": "Zentek",
                "name": "VidaAtiva Assist",
                "contact": {
                  "phone": "Aplicativo VidaAssist",
                  "email": "suporte@zentek.com.br",
                  "website": "https://www.zentek.com.br"
                }
              },
              "activationProcess": "Acesso via aplicativo",
              "supportContact": {
                "phone": "Aplicativo VidaAssist",
                "email": "suporte@zentek.com.br",
                "appLink": "https://www.zentek.com.br"
              },
              "benefitDuration": "O serviço estará disponível enquanto o cliente estiver com a assinatura ativa e sem inadimplência",
              "adjustmentRules": "O Provedor  reserva-se o direito de fazer alterações nos serviços a qualquer momento, com o objetivo de melhorar a qualidade, a abrangência ou a eficácia dos serviços oferecidos aos clientes.",
              "cancellationPolicy": {
                "terms": "Pode ser cancelado a qualquer momento, via aplicativo.",
                "penalty": "Sem multas"
              }
            }            
          ]          
        },
        {
          "_id": "635f8a5a6c9d4f7c8e9d5b16",
          "name": "Meu Amigo Tech",
          "description": "Technical support for digital devices.",
          "coverages": [
            {
              "benefitName": "Suporte Tecnológico para Dispositivos Digitais",
              "coverageType": "suporte_tecnológico",
              "coverageAmount": "Ilimitado",
              "usageLimit": "Horário comercial",
              "waitingPeriod": "48 horas úteis",
              "includedServices": [
                "Suporte técnico remoto para computadores, notebooks, impressoras, redes Wifi; configuração de smartphones e tablets, integração e suporte para dispositivos inteligentes, remoção de malware, vírus e programas indesejados, entre outros."
              ],
              "exclusions": [
                "Aplicativos não padrão de mercado e softwares proprietários, licença de software, hardware e atendimento presencial."
              ],
              "eligibleBeneficiaries": "Titular",
              "provider": {
                "type": "Zentek",
                "name": "VidaAtiva Assist",
                "contact": {
                  "phone": "Aplicativo VidaAssist",
                  "email": "suporte@zentek.com.br",
                  "website": "https://www.zentek.com.br"
                }
              },
              "activationProcess": "Acesso via aplicativo",
              "supportContact": {
                "phone": "Aplicativo VidaAssist",
                "email": "suporte@zentek.com.br",
                "appLink": "https://www.zentek.com.br"
              },
              "benefitDuration": "O serviço estará disponível enquanto o cliente estiver com a assinatura ativa e sem inadimplência",
              "adjustmentRules": "O Provedor  reserva-se o direito de fazer alterações nos serviços a qualquer momento, com o objetivo de melhorar a qualidade, a abrangência ou a eficácia dos serviços oferecidos aos clientes.",
              "cancellationPolicy": {
                "terms": "Pode ser cancelado a qualquer momento, via aplicativo.",
                "penalty": "Sem multas"
              }
            },                  
            {
              "benefitName": "Suporte Tecnológico para Automação Residencial",
              "coverageType": "suporte_tecnológico",
              "coverageAmount": "Ilimitado",
              "usageLimit": "Horário comercial",
              "waitingPeriod": "48 horas úteis",
              "includedServices": [
                "Suporte técnico remoto para computadores, notebooks, impressoras, redes Wifi; configuração de smartphones e tablets, integração e suporte para dispositivos inteligentes, remoção de malware, vírus e programas indesejados, entre outros."
              ],
              "exclusions": [
                "Aplicativos não padrão de mercado e softwares proprietários, licença de software, hardware e atendimento presencial."
              ],
              "eligibleBeneficiaries": "Titular",
              "provider": {
                "type": "Zentek",
                "name": "VidaAtiva Assist",
                "contact": {
                  "phone": "Aplicativo VidaAssist",
                  "email": "suporte@zentek.com.br",
                  "website": "https://www.zentek.com.br"
                }
              },
              "activationProcess": "Acesso via aplicativo",
              "supportContact": {
                "phone": "Aplicativo VidaAssist",
                "email": "suporte@zentek.com.br",
                "appLink": "https://www.zentek.com.br"
              },
              "benefitDuration": "O serviço estará disponível enquanto o cliente estiver com a assinatura ativa e sem inadimplência",
              "adjustmentRules": "O Provedor  reserva-se o direito de fazer alterações nos serviços a qualquer momento, com o objetivo de melhorar a qualidade, a abrangência ou a eficácia dos serviços oferecidos aos clientes.",
              "cancellationPolicy": {
                "terms": "Pode ser cancelado a qualquer momento, via aplicativo.",
                "penalty": "Sem multas"
              }
            },            
            {
              "benefitName": "Assistência Residencial",
              "coverageType": "assistência_residencia",
              "coverageAmount": "6 acionamentos por ano",
              "usageLimit": "acesso 24/7",
              "waitingPeriod": "5 (cinco) dias úteis",
              "includedServices": [
                "Serviços de emergência como encanador, eletricista ou chaveiro."
              ],
              "exclusions": [
                "Não cobre serviços como reformas, pintura, colocação de pisos ou revestimentos. Reparos que envolvam alterações estruturais também estão excluídos."
              ],
              "eligibleBeneficiaries": "Titular",
              "provider": {
                "type": "Mawdy",
                "name": "VidaAtiva Assist",
                "contact": {
                  "phone": "Telefone: 0800 544 4848 / WhatsApp: (11) 974907-218O",
                  "email": "suporte@zentek.com.br",
                  "website": "https://www.zentek.com.br"
                }
              },
              "activationProcess": "Telefone",
              "supportContact": {
                "phone": "Telefone: 0800 544 4848 / WhatsApp: (11) 974907-218O",
                "email": "suporte@zentek.com.br",
                "appLink": "https://www.zentek.com.br"
              },
              "benefitDuration": "O serviço estará disponível enquanto o cliente estiver com a assinatura ativa e sem inadimplência",
              "adjustmentRules": "O Provedor  reserva-se o direito de fazer alterações nos serviços a qualquer momento, com o objetivo de melhorar a qualidade, a abrangência ou a eficácia dos serviços oferecidos aos clientes.",
              "cancellationPolicy": {
                "terms": "Pode ser cancelado a qualquer momento, via aplicativo.",
                "penalty": "Sem multas"
              }
            }            
          ]          
        },
        {
          "_id": "635f8a5a6c9d4f7c8e9d5b17",
          "name": "Guardião Digital",
          "description": "Technical support for digital devices.",
          "coverages": [
            {
              "benefitName": "Gestão e Educação em Cybersegurança",
              "coverageType": "suporte_tecnológico",
              "coverageAmount": "Ilimitado",
              "usageLimit": "acesso 24/7",
              "waitingPeriod": "5 (cinco) dias úteis",
              "includedServices": [
                "Consultas online com orientações sobre boas práticas de cibersegurança, suporte em caso de incidentes cibernéticos e proteção de dados pessoais."
              ],
              "exclusions": [
                "Atendimento humano."
              ],
              "eligibleBeneficiaries": "Titular",
              "provider": {
                "type": "Zentek",
                "name": "VidaAtiva Assist",
                "contact": {
                  "phone": "Aplicativo VidaAssist",
                  "email": "suporte@zentek.com.br",
                  "website": "https://www.zentek.com.br"
                }
              },
              "activationProcess": "Acesso via aplicativo",
              "supportContact": {
                "phone": "Aplicativo VidaAssist",
                "email": "suporte@zentek.com.br",
                "appLink": "https://www.zentek.com.br"
              },
              "benefitDuration": "O serviço estará disponível enquanto o cliente estiver com a assinatura ativa e sem inadimplência",
              "adjustmentRules": "O Provedor  reserva-se o direito de fazer alterações nos serviços a qualquer momento, com o objetivo de melhorar a qualidade, a abrangência ou a eficácia dos serviços oferecidos aos clientes.",
              "cancellationPolicy": {
                "terms": "Pode ser cancelado a qualquer momento, via aplicativo.",
                "penalty": "Sem multas"
              }
            },            
            {
              "benefitName": "Suporte com Especialistas em Cybersegurança",
              "coverageType": "suporte_tecnológico",
              "coverageAmount": "Ilimitado",
              "usageLimit": "Horário comercial",
              "waitingPeriod": "48 horas úteis",
              "includedServices": [
                "Atendimento remoto com especialistas que fornece aos usuários as ferramentas e o suporte necessários para prevenir, identificar e responder a incidentes de segurança digital, garantindo a integridade de seus dados e informações pessoais."
              ],
              "exclusions": [],
              "eligibleBeneficiaries": "Titular",
              "provider": {
                "type": "Zentek",
                "name": "VidaAtiva Assist",
                "contact": {
                  "phone": "Aplicativo VidaAssist",
                  "email": "suporte@zentek.com.br",
                  "website": "https://www.zentek.com.br"
                }
              },
              "activationProcess": "Acesso via aplicativo",
              "supportContact": {
                "phone": "Aplicativo VidaAssist",
                "email": "suporte@zentek.com.br",
                "appLink": ""
              },
              "benefitDuration": "O serviço estará disponível enquanto o cliente estiver com a assinatura ativa e sem inadimplência",
              "adjustmentRules": "O Provedor  reserva-se o direito de fazer alterações nos serviços a qualquer momento, com o objetivo de melhorar a qualidade, a abrangência ou a eficácia dos serviços oferecidos aos clientes.",
              "cancellationPolicy": {
                "terms": "Pode ser cancelado a qualquer momento, via aplicativo.",
                "penalty": "Sem multas"
              }
            }            
          ]       
        },
        {
          "_id": "635f8a5a6c9d4f7c8e9d5b18",
          "name": "Meu Legado",
          "description": "Technical support for digital devices.",
          "coverages": [
            {
              "benefitName": "Assistência Funeral",
              "coverageType": "assistência_funeral",
              "coverageAmount": "Até R$ 5000,00",
              "usageLimit": "01 (um) acionamento por vigência da assinatura",
              "waitingPeriod": "24 horas úteis",
              "includedServices": [
                "Inclui despesas com o funeral, incluindo tratamento do corpo, preparação do velório, ornamentação, translado, coroa de flores e cremação ou sepultamento, até o valor máximo de R$ 5000,00."
              ],
              "exclusions": [
                "Evento decorrente de: Práticas ilegais, fenômenos naturais extraordinários, eventos decorrentes de terrorismo ou tumultos, atuação das forças armadas, energia nuclear ou radioativa, homicídio decorrente de atos ilícitos."
              ],
              "eligibleBeneficiaries": "Titular",
              "provider": {
                "type": "MEG",
                "name": "VidaAtiva Assist",
                "contact": {
                  "phone": "8,008,782,791",
                  "email": "suporte@zentek.com.br",
                  "website": "https://www.zentek.com.br"
                }
              },
              "activationProcess": "Telefone",
              "supportContact": {
                "phone": "Telefone",
                "email": "suporte@zentek.com.br",
                "appLink": "https://www.zentek.com.br"
              },
              "benefitDuration": "O serviço estará disponível enquanto o cliente estiver com a assinatura ativa e sem inadimplência",
              "adjustmentRules": "O Provedor reserva-se o direito de fazer alterações nos serviços a qualquer momento, com o objetivo de melhorar a qualidade, a abrangência ou a eficácia dos serviços oferecidos aos clientes.",
              "cancellationPolicy": {
                "terms": "Pode ser cancelado a qualquer momento, via aplicativo.",
                "penalty": "Sem multas"
              }
            },            
            {
              "benefitName": "Gestão de Ativos Digitais",
              "coverageType": "suporte_tecnológico",
              "coverageAmount": "Ilimitado",
              "usageLimit": "Ilimitado",
              "waitingPeriod": "48 horas úteis",
              "includedServices": [
                "Suporte no planejamento e organização de ativos digitais, relacionadas à sucessão e ao cuidado com ativos, como contas de e-mail, redes sociais, serviços online e armazenamento de dados.",
                "O usuário pode definir o que será feito com suas contas digitais após seu falecimento."
              ],
              "exclusions": [
                "Violação de dados em 'Cloud Computing', hardware e atendimento presencial, assistência jurídica, dispositivos para backup, suporte para aplicações e/ou problemas de dispositivos digitais."
              ],
              "eligibleBeneficiaries": "Titular",
              "provider": {
                "type": "Zentek",
                "name": "VidaAtiva Assist",
                "contact": {
                  "phone": "",
                  "email": "suporte@zentek.com.br",
                  "website": "https://www.zentek.com.br"
                }
              },
              "activationProcess": "Acesso via aplicativo",
              "supportContact": {
                "phone": "app",
                "email": "suporte@zentek.com.br",
                "appLink": "https://www.zentek.com.br"
              },
              "benefitDuration": "O serviço estará disponível enquanto o cliente estiver com a assinatura ativa e sem inadimplência",
              "adjustmentRules": "O Provedor reserva-se o direito de fazer alterações nos serviços a qualquer momento, com o objetivo de melhorar a qualidade, a abrangência ou a eficácia dos serviços oferecidos aos clientes.",
              "cancellationPolicy": {
                "terms": "Pode ser cancelado a qualquer momento, via aplicativo.",
                "penalty": "Sem multas"
              }
            },            
            {
              "benefitName": "Planejamento Sucessório e Testamentos",
              "coverageType": "planejamento_pessoal",
              "coverageAmount": "01 (um) acionamento por vigência da assinatura",
              "usageLimit": "Anual",
              "waitingPeriod": "15 (quinze) dias úteis",
              "includedServices": [
                "Orientação jurídica para elaboração de testamento, inventário e orientação sobre processos de doação e sucessão."
              ],
              "exclusions": [
                "Não inclui serviços de cartório e registro dos documentos."
              ],
              "eligibleBeneficiaries": "Titular",
              "provider": {
                "type": "Zentek",
                "name": "VidaAtiva Assist",
                "contact": {
                  "phone": "",
                  "email": "suporte@zentek.com.br",
                  "website": "https://www.zentek.com.br"
                }
              },
              "activationProcess": "Acesso via aplicativo",
              "supportContact": {
                "phone": "app",
                "email": "suporte@zentek.com.br",
                "appLink": "https://www.zentek.com.br"
              },
              "benefitDuration": "O serviço estará disponível enquanto o cliente estiver com a assinatura ativa e sem inadimplência",
              "adjustmentRules": "O Provedor reserva-se o direito de fazer alterações nos serviços a qualquer momento, com o objetivo de melhorar a qualidade, a abrangência ou a eficácia dos serviços oferecidos aos clientes.",
              "cancellationPolicy": {
                "terms": "Pode ser cancelado a qualquer momento, via aplicativo.",
                "penalty": "Sem multas"
              }
            },            
            {
              "benefitName": "Cuidados com o Pet",
              "coverageType": "planejamento_pessoal",
              "coverageAmount": "01 (um) acionamento por vigência da assinatura",
              "usageLimit": "Horário comercial",
              "waitingPeriod": "15 (quinze) dias úteis",
              "includedServices": [
                "Este serviço garante o bem-estar dos animais de estimação em caso de falecimento do dono, incluindo o acolhimento do pet e sua realocação em um novo lar ou instituição de cuidados."
              ],
              "exclusions": [
                "Custos com hotel, veterinário, transporte."
              ],
              "eligibleBeneficiaries": "Titular",
              "provider": {
                "type": "(a definir)",
                "name": "VidaAtiva Assist",
                "contact": {
                  "phone": "",
                  "email": "suporte@zentek.com.br",
                  "website": "https://www.zentek.com.br"
                }
              },
              "activationProcess": "(a definir)",
              "supportContact": {
                "phone": "app",
                "email": "suporte@zentek.com.br",
                "appLink": "https://www.zentek.com.br"
              },
              "benefitDuration": "O serviço estará disponível enquanto o cliente estiver com a assinatura ativa e sem inadimplência",
              "adjustmentRules": "O Provedor reserva-se o direito de fazer alterações nos serviços a qualquer momento, com o objetivo de melhorar a qualidade, a abrangência ou a eficácia dos serviços oferecidos aos clientes.",
              "cancellationPolicy": {
                "terms": "Pode ser cancelado a qualquer momento, via aplicativo.",
                "penalty": "Sem multas"
              }
            }            
          ] 
        },
        {
          "_id": "635f8a5a6c9d4f7c8e9d5b19",
          "name": "Suporte Financeiro",
          "description": "Technical support for digital devices.",
          "coverages": [
            {
              "benefitName": "Suporte Online",
              "coverageType": "planejamento_pessoal",
              "coverageAmount": "Ilimitado",
              "usageLimit": "Horário comercial",
              "waitingPeriod": "48 horas úteis",
              "includedServices": [
                "Serviço de suporte online que oferece dicas e orientação sobre planejamento financeiro e investimentos."
              ],
              "exclusions": [
                "Suporte contábil e jurídico."
              ],
              "eligibleBeneficiaries": "Titular",
              "provider": {
                "type": "Financial Assistance Service",
                "name": "VidaAtiva Assist",
                "contact": {
                  "phone": "",
                  "email": "suporte@zentek.com.br",
                  "website": "https://www.zentek.com.br"
                }
              },
              "activationProcess": "Acesso via aplicativo",
              "supportContact": {
                "phone": "app",
                "email": "suporte@zentek.com.br",
                "appLink": "https://www.zentek.com.br"
              },
              "benefitDuration": "O serviço estará disponível enquanto o cliente estiver com a assinatura ativa e sem inadimplência",
              "adjustmentRules": "O Provedor reserva-se o direito de fazer alterações nos serviços a qualquer momento, com o objetivo de melhorar a qualidade, a abrangência ou a eficácia dos serviços oferecidos aos clientes.",
              "cancellationPolicy": {
                "terms": "Pode ser cancelado a qualquer momento, via aplicativo.",
                "penalty": "Sem multas"
              }
            },            
            {
              "benefitName": "Treinamentos Online",
              "coverageType": "suporte_tecnológico",
              "coverageAmount": "Ilimitado",
              "usageLimit": "acesso 24/7",
              "waitingPeriod": "15 (quinze) dias úteis",
              "includedServices": [
                "Conteúdos de microlearning com temas tecnológicos práticos para o dia a dia, como tutoriais sobre dispositivos móveis, aplicativos úteis, segurança digital e atualizações sobre novas ferramentas tecnológicas."
              ],
              "exclusions": [
                "Não inclui suporte tecnológico."
              ],
              "eligibleBeneficiaries": "Titular",
              "provider": {
                "type": "Educational Service",
                "name": "VidaAtiva Assist",
                "contact": {
                  "phone": "",
                  "email": "suporte@zentek.com.br",
                  "website": "https://www.zentek.com.br"
                }
              },
              "activationProcess": "Acesso via aplicativo",
              "supportContact": {
                "phone": "app",
                "email": "suporte@zentek.com.br",
                "appLink": "https://www.zentek.com.br"
              },
              "benefitDuration": "O serviço estará disponível enquanto o cliente estiver com a assinatura ativa e sem inadimplência",
              "adjustmentRules": "O Provedor reserva-se o direito de fazer alterações nos serviços a qualquer momento, com o objetivo de melhorar a qualidade, a abrangência ou a eficácia dos serviços oferecidos aos clientes.",
              "cancellationPolicy": {
                "terms": "Pode ser cancelado a qualquer momento, via aplicativo.",
                "penalty": "Sem multas"
              }
            },            
            {
              "benefitName": "Sugestões e Atualizações Tecnológicas",
              "coverageType": "suporte_tecnológico",
              "coverageAmount": "Ilimitado",
              "usageLimit": "acesso 24/7",
              "waitingPeriod": "15 (quinze) dias úteis",
              "includedServices": [
                "Os conteúdos são práticos, curtos e de fácil aplicação no dia a dia, permitindo ao assinante aprender rapidamente sobre o que há de mais relevante em tecnologia."
              ],
              "exclusions": [
                "Não inclui suporte tecnológico."
              ],
              "eligibleBeneficiaries": "Titular",
              "provider": {
                "type": "Tech Advisory Service",
                "name": "VidaAtiva Assist",
                "contact": {
                  "phone": "",
                  "email": "suporte@zentek.com.br",
                  "website": "https://www.zentek.com.br"
                }
              },
              "activationProcess": "Acesso via aplicativo",
              "supportContact": {
                "phone": "app",
                "email": "suporte@zentek.com.br",
                "appLink": "https://www.zentek.com.br"
              },
              "benefitDuration": "O serviço estará disponível enquanto o cliente estiver com a assinatura ativa e sem inadimplência",
              "adjustmentRules": "O Provedor reserva-se o direito de fazer alterações nos serviços a qualquer momento, com o objetivo de melhorar a qualidade, a abrangência ou a eficácia dos serviços oferecidos aos clientes.",
              "cancellationPolicy": {
                "terms": "Pode ser cancelado a qualquer momento, via aplicativo.",
                "penalty": "Sem multas"
              }
            }            
          ]
        },
        {
          "_id": "635f8a5a6c9d4f7c8e9d5b29",
          "name": "Vai e Volta",
          "description": "Technical support for digital devices.",
          "coverages": [
            {
              "benefitName": "Serviço de Transporte Especializado",
              "coverageType": "concierge",
              "coverageAmount": "Ilimitado",
              "usageLimit": "Por demanda",
              "waitingPeriod": "15 (quinze) dias úteis",
              "includedServices": [
                "Serviço de transporte especializado para atender às necessidades de deslocamento, como consultas médicas ou compromissos importantes."
              ],
              "exclusions": [
                "Serviço de acompanhamento, equipamentos para mobilidade."
              ],
              "eligibleBeneficiaries": "Titular",
              "provider": {
                "type": "Transportation Service",
                "name": "Vô Contigo",
                "contact": {
                  "phone": "",
                  "email": "suporte@zentek.com.br",
                  "website": "https://www.zentek.com.br"
                }
              },
              "activationProcess": "Acesso via aplicativo",
              "supportContact": {
                "phone": "app",
                "email": "suporte@zentek.com.br",
                "appLink": "https://www.zentek.com.br"
              },
              "benefitDuration": "O serviço estará disponível enquanto o cliente estiver com a assinatura ativa e sem inadimplência",
              "adjustmentRules": "O Provedor reserva-se o direito de fazer alterações nos serviços a qualquer momento, com o objetivo de melhorar a qualidade, a abrangência ou a eficácia dos serviços oferecidos aos clientes.",
              "cancellationPolicy": {
                "terms": "Pode ser cancelado a qualquer momento, via aplicativo.",
                "penalty": "Sem multas"
              }
            }           
          ] 
        }
      ],
      "pricing": {
        "monthly_fee": 79.99,
        "annual_fee": 899.99,
        "currency": "USD"
      },
      "benefits": [
        {
          "name": "Telemedicine Access",
          "description": "Access to virtual healthcare consultations."
        },
        {
          "name": "24/7 Emergency Support",
          "description": "Emergency assistance anytime, anywhere."
        }
      ],
      "add_ons": [
        {
          "name": "Dental Coverage",
          "price": 9.99,
          "currency": "USD"
        },
        {
          "name": "Vision Coverage",
          "price": 5.99,
          "currency": "USD"
        }
      ]
  }
 
);
// Mock endpoint for affiliate links
mock.onGet(new RegExp(`/affiliate-links/[a-zA-Z0-9]+`)).reply(200, {
  affiliate_link: "PPBqWA9",
  affiliate_id: "pU7bV0d",
  affiliate_name: "Jornada TOP",
  plan_id: "PPBqWA9",
  installements: "12",
  name: "Casa Conectada",
});

// Mock endpoint for plans
mock.onGet(new RegExp(`/plans/[a-zA-Z0-9]+`)).reply(200, [
  {
    plan_id: "PPBqWA9",
    sku: "1",
    img: "https://placehold.co/50x50",
    name: "Casa Conectada",
    description: "12x de R$ 10,90 ou R$ 129,90 à vista no PIX",
    quantity: "1",
    amount: "129.90",
  },
]);

// Mock endpoint for addons
mock.onGet("/addons").reply(200, [
  {
    plan_id: "PPBqWA9",
    sku: "2",
    img: "https://placehold.co/50x50",
    name: "Casa Conectada",
    description: "12x de R$ 10,90 ou R$ 129,90 à vista no PIX",
    quantity: "1",
    amount: "129.90",
  },
  {
    plan_id: "PPBqWA9",
    sku: "4",
    img: "https://placehold.co/50x50",
    name: "Casa Conectada",
    description: "12x de R$ 10,90 ou R$ 129,90 à vista no PIX",
    quantity: "1",
    amount: "129.90",
  },
  // Add more objects here if needed
]);

// Mock the POST /checkout endpoint
// mock.onPost("/checkout").reply((config) => {
//   const data = JSON.parse(config.data);
//   // return new Promise((resolve) => {
//   //   setTimeout(async () => {
//   //     const response = await requestPayment(data);
//   //     resolve(response);
//   //   }, 3000); // 30 seconds delay
//   // });
// });

// mock.onPost("/remarketing").reply(200, {
//   message: "Remarketing data received",
// });

export default mock;
